export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8828.00a64bc6.jpg";